<template><div><h1>VUX V2.2.1Rc.4 发布日志</h1>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] 支持通过 prop:label-position 设置 label位置</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/previewer.html">Previewer</a></h2>
<ul><li>[enhance] 增加关闭事件 #1245</li>
</ul>
<h2><a href="/zh-CN/components/scroller.html">Scroller</a></h2>
<ul><li>[feature] 支持在滚回顶部时设置时间和缓动 #1240</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[enhance] 支持 on-item-click 带上 index 参数</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 支持设置 label 宽度 #1186</li>
</ul>
<h2><a href="/zh-CN/components/x-table.html">XTable</a></h2>
<ul><li>[feature] 新组件</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.4-223.vue?52384beb